<app-so-content [isActive]="isActive">
  <div class="assets-tree">
    <div class="assets-tree__title">
      <h1>{{assets?.length ? 'Select your assets' : 'No assets received'}}</h1>
    </div>
    <div class="assets-tree__tree">
      <div *ngFor="let country of assets; let countryIdx = index">
        <!-- country -->
        <div>
          <svg viewBox="0 0 34 64">
            <g>
              <path class="bullet"
                    [class.active]="country.selected"
                    d="M 25.439127,8.2668774 25.566227,22.3327 13.448418,29.475683 1.2035081,22.552843 1.0764088,8.4870199 13.194218,1.3440377 Z"
                    (click)="onSelect(country, !country.selected, countryIdx)">
              </path>
              <path d="m 13.448418,29.475683 -0.0639,24.062402 8.333759,7.828682 10.985409,-0.126269"></path>
            </g>
          </svg>
          <h2>{{country.label}}</h2>
          <!-- customer -->
          <div *ngFor="let customer of country.customers">
            <svg viewBox="0 0 34 64">
              <g>
                <path class="bullet"
                      [class.active]="customer.selected"
                      d="M 25.439127,8.2668774 25.566227,22.3327 13.448418,29.475683 1.2035081,22.552843 1.0764088,8.4870199 13.194218,1.3440377 Z"
                      (click)="onSelect(customer, !customer.selected, countryIdx)">
                </path>
                <path d="m 13.448418,29.475683 -0.0639,24.062402 8.333759,7.828682 10.985409,-0.126269"></path>
              </g>
            </svg>
            <h3>{{customer.label}}</h3>
            <div *ngFor="let cat of customer.cats">
              <svg viewBox="0 0 34 64">
                <g>
                  <path class="bullet"
                        [class.active]="cat.selected"
                        d="M 25.439127,8.2668774 25.566227,22.3327 13.448418,29.475683 1.2035081,22.552843 1.0764088,8.4870199 13.194218,1.3440377 Z"
                        (click)="onSelect(cat, !cat.selected, countryIdx)">
                  </path>
                  <path d="m 13.448418,29.475683 -0.0639,24.062402 8.333759,7.828682 10.985409,-0.126269"></path>
                </g>
              </svg>
              <strong>{{cat.label}}</strong>
              <div *ngFor="let asset of cat.assets; last as isLast">
                <svg viewBox="0 0 34 64">
                  <g>
                    <path class="bullet"
                          [class.active]="asset.selected"
                          d="M 25.439127,8.2668774 25.566227,22.3327 13.448418,29.475683 1.2035081,22.552843 1.0764088,8.4870199 13.194218,1.3440377 Z"
                          (click)="onSelect(asset, !asset.selected, countryIdx)">
                    </path>
                    <path *ngIf="!isLast" d="m 13.448418,29.475683 -0.0639,16.062402"></path>
                  </g>
                </svg>
                {{asset.label}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-so-content>
